import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import {DangerButton} from 'Components/Button';

import {translation} from 'Services/TranslationHelpers';

export default class Splash extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <Unauthenticated>
                <div>
                    {translation('splash_page', 'welcome', {
                        SITE_NAME: 'Package Example'
                    })}
                </div>
            </Unauthenticated>
        );
    }
}
